import { render, staticRenderFns } from "./UploadMediaDialog.vue?vue&type=template&id=0e8aa37d&scoped=true"
import script from "./UploadMediaDialog.ts?vue&type=script&lang=ts&external"
export * from "./UploadMediaDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./UploadMediaDialog.scss?vue&type=style&index=0&id=0e8aa37d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8aa37d",
  null
  
)

export default component.exports